import React from 'react';
import {
  Pane, majorScale, TextInput, FormField,
} from 'evergreen-ui';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  SelectTeamInput,
  SelectLocationInput,
} from '../../../../../../components/inputs';

const UserDataStep = (formik, customFields) => {
  const {
    values, errors, touched, handleChange, setFieldValue,
  } = formik;

  const stepFields = [
    'first_name',
    'last_name',
    'personal_email',
    'team',
    'location',
    ...(customFields.includes('mobile_number') ? ['mobile_number'] : []),
    ...(customFields.includes('join_date') ? ['join_date'] : []),
    ...(customFields.includes('experience') ? ['experience'] : []),
    ...(customFields.includes('job_title') ? ['job_title'] : []),
    ...(customFields.includes('business_unit') ? ['business_unit'] : []),
    ...(customFields.includes('department') ? ['department'] : []),
    ...(customFields.includes('recruiter_name') ? ['recruiter_name'] : []),
    ...(customFields.includes('birth_date') ? ['birth_date'] : []),
    ...(customFields.includes('reporting_manager') ? ['reporting_manager'] : []),
    ...(customFields.includes('identification') ? ['identification'] : []),
    ...(customFields.includes('address') ? ['address'] : []),
  ];
  const stepErrors = Object.fromEntries(
    Object.entries(errors).filter(
      ([key]) => stepFields.includes(key) && touched[key]
    )
  );

  return {
    title: 'User data',
    body: (
      <Pane display="grid" gridTemplateColumns="repeat(4, 1fr)" gridGap={majorScale(2)}>
        <FormField label="First name" validationMessage={stepErrors.first_name}>
          <TextInput
            data-testid="first_name"
            name="first_name"
            onChange={handleChange}
            defaultValue={values.first_name}
            isInvalid={stepErrors.first_name && true} />
        </FormField>

        <FormField label="Last name" validationMessage={stepErrors.last_name}>
          <TextInput
            data-testid="last_name"
            name="last_name"
            onChange={handleChange}
            defaultValue={values.last_name}
            isInvalid={stepErrors.last_name && true} />
        </FormField>

        <FormField label="Personal email" validationMessage={stepErrors.personal_email}>
          <TextInput
            data-testid="personal_email"
            name="personal_email"
            onChange={handleChange}
            defaultValue={values.personal_email}
            isInvalid={stepErrors.personal_email && true} />
        </FormField>

        <FormField label="Team" validationMessage={stepErrors.team}>
          <SelectTeamInput
            defaultValue={values.team}
            onChange={(selected) => {
              const departmentName = selected.name;
              formik.setFieldValue('team', selected);
              formik.setFieldValue('department', departmentName);
              console.log(departmentName);
            }} />

        </FormField>

        <FormField label="Location" validationMessage={stepErrors.location}>
          <SelectLocationInput
            defaultValue={values.location}
            onChange={(selected) => formik.setFieldValue('location', selected)} />
        </FormField>

        {customFields.includes('mobile_number') && (
          <FormField label="Mobile Number" validationMessage={stepErrors.mobile_number}>
            <PhoneInput
              country={'ar'}
              value={values.mobile_number}
              onChange={(phone) => setFieldValue('mobile_number', phone)}
              inputProps={{
                name: 'mobile_number',
                required: true,
                'data-testid': 'mobile_number',
              }}
              isValid={!stepErrors.mobile_number}
            />
          </FormField>
        )}

        {customFields.includes('join_date') && (
          <FormField label="Date of Joining" validationMessage={stepErrors.join_date}>
            <TextInput
              data-testid="join_date"
              name="join_date"
              type="date"
              width="40%"
              value={values.join_date || ''}
              min={new Date().toISOString().split('T')[0]}
              onChange={e => formik.setFieldValue('join_date', e.target.value)}
              isInvalid={stepErrors.join_date && true} />
          </FormField>
        )}

        {customFields.includes('birth_date') && (
          <FormField label="Date of Birth" validationMessage={stepErrors.birth_date}>
            <TextInput
              data-testid="birth_date"
              name="birth_date"
              type="date"
              width="40%"
              value={values.birth_date || ''}
              min={new Date().toISOString().split('T')[0]}
              onChange={e => formik.setFieldValue('birth_date', e.target.value)}
              isInvalid={stepErrors.birth_date && true} />
          </FormField>
        )}

        {customFields.includes('recruiter_name') && (
          <FormField label="Recruiter Name" validationMessage={stepErrors.recruiter_name}>
            <TextInput
              data-testid="recruiter_name"
              name="recruiter_name"
              onChange={handleChange}
              defaultValue={values.recruiter_name}
              isInvalid={stepErrors.recruiter_name && true} />
          </FormField>
        )}
        
        {customFields.includes('experience') && (
          <FormField label="Experience (In years)" validationMessage={stepErrors.experience}>
            <TextInput
              data-testid="experience"
              name="experience"
              onChange={handleChange}
              defaultValue={values.experience}
              isInvalid={stepErrors.experience && true} />
          </FormField>
        )}

        {customFields.includes('job_title') && (
          <FormField label="Designation (Job title)" validationMessage={stepErrors.job_title}>
            <TextInput
              data-testid="job_title"
              name="job_title"
              onChange={handleChange}
              defaultValue={values.job_title}
              width="100%"
              isInvalid={stepErrors.job_title && true} />
          </FormField>
        )}

        {customFields.includes('business_unit') && (
          <FormField label="Platform & BU" validationMessage={stepErrors.business_unit}>
            <TextInput
              data-testid="business_unit"
              name="business_unit"
              onChange={handleChange}
              defaultValue={values.business_unit}
              isInvalid={stepErrors.business_unit && true} />
          </FormField>
        )}

        {customFields.includes('department') && (
          <FormField label="Department" validationMessage={stepErrors.department}>
            <TextInput
              data-testid="department"
              name="department"
              value={values.department}
              isDisabled={true}
              readOnly
            />
          </FormField>
        )}

        {customFields.includes('reporting_manager') && (
          <FormField label="Reporting Manager" validationMessage={stepErrors.reporting_manager}>
            <TextInput
              data-testid="reporting_manager"
              name="reporting_manager"
              width="100%"
              onChange={handleChange}
              defaultValue={values.reporting_manager}
              isInvalid={stepErrors.reporting_manager && true} />
          </FormField>
        )}

        {customFields.includes('identification') && (
          <FormField label="ID" validationMessage={stepErrors.identification}>
            <TextInput
              data-testid="identification"
              name="identification"
              width="40%"
              placeholder="DNI, CPF, SSN, etc."
              onChange={handleChange}
              defaultValue={values.identification}
              isInvalid={stepErrors.identification && true} />
          </FormField>
        )}

        {customFields.includes('address') && (
          <FormField label="Laptop Delivery Address" validationMessage={stepErrors.address}>
            <TextInput
              data-testid="address"
              name="address"
              onChange={handleChange}
              width="100%"
              defaultValue={values.address}
              isInvalid={stepErrors.address && true} />
          </FormField>
        )}
      </Pane>
    ),
  };
};

export default UserDataStep;
